import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { Request } from '@/utils/request';
import VueAxios from 'vue-axios'
import 'lib-flexible' // px  转化  rem  比例375/10=37.5px  1rem=37.5px

const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
app.component(key, component)
}

app.use(ElementPlus)
app.use(store)
app.use(router)
app.mount('#app')
app.use(VueAxios, Request.init())

// createApp(App).use(store).use(router).mount('#app')
